/* @generated from adl module ferovinum.app.dtos */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './db';

export interface AbvValue_Single {
  kind: 'single';
  value: number;
}
export interface AbvValue_Range {
  kind: 'range';
  value: AbvRange;
}

/**
 * ABV value - either single value (regular products) or range (assembled products)
 */
export type AbvValue = AbvValue_Single | AbvValue_Range;

export interface AbvValueOpts {
  single: number;
  range: AbvRange;
}

export function makeAbvValue<K extends keyof AbvValueOpts>(kind: K, value: AbvValueOpts[K]) { return {kind, value}; }

const AbvValue_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.dtos","decl":{"annotations":[{"value":"ABV value - either single value (regular products) or range (assembled products)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"single","default":{"kind":"nothing"},"name":"single","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"range","default":{"kind":"nothing"},"name":"range","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.dtos","name":"AbvRange"}},"parameters":[]}}]}},"name":"AbvValue","version":{"kind":"nothing"}}};

export const snAbvValue: ADL.ScopedName = {moduleName:"ferovinum.app.dtos", name:"AbvValue"};

export function texprAbvValue(): ADL.ATypeExpr<AbvValue> {
  return {value : {typeRef : {kind: "reference", value : snAbvValue}, parameters : []}};
}

export interface AbvRange {
  min: number;
  max: number;
}

export function makeAbvRange(
  input: {
    min: number,
    max: number,
  }
): AbvRange {
  return {
    min: input.min,
    max: input.max,
  };
}

const AbvRange_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.dtos","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"min","default":{"kind":"nothing"},"name":"min","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"max","default":{"kind":"nothing"},"name":"max","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"AbvRange","version":{"kind":"nothing"}}};

export const snAbvRange: ADL.ScopedName = {moduleName:"ferovinum.app.dtos", name:"AbvRange"};

export function texprAbvRange(): ADL.ATypeExpr<AbvRange> {
  return {value : {typeRef : {kind: "reference", value : snAbvRange}, parameters : []}};
}

/**
 * API DTO for getting ProductStockDetail objects
 */
export interface GetProductStockDetailDto {
  ref: ferovinum_app_db.ProductStockDetailRef;
  batchNumber: (string|null);
  bestBeforeDate: (common.LocalDate|null);
  rotationNumber: (string|null);
  rotationLine: (string|null);
  quantity: common.BigDecimal;
  dutyPaid: (boolean|null);
}

export function makeGetProductStockDetailDto(
  input: {
    ref: ferovinum_app_db.ProductStockDetailRef,
    batchNumber: (string|null),
    bestBeforeDate: (common.LocalDate|null),
    rotationNumber: (string|null),
    rotationLine: (string|null),
    quantity: common.BigDecimal,
    dutyPaid: (boolean|null),
  }
): GetProductStockDetailDto {
  return {
    ref: input.ref,
    batchNumber: input.batchNumber,
    bestBeforeDate: input.bestBeforeDate,
    rotationNumber: input.rotationNumber,
    rotationLine: input.rotationLine,
    quantity: input.quantity,
    dutyPaid: input.dutyPaid,
  };
}

const GetProductStockDetailDto_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.dtos","decl":{"annotations":[{"value":"API DTO for getting ProductStockDetail objects\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"ref","default":{"kind":"nothing"},"name":"ref","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductStockDetailRef"}},"parameters":[]}},{"annotations":[],"serializedName":"batchNumber","default":{"kind":"nothing"},"name":"batchNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"bestBeforeDate","default":{"kind":"nothing"},"name":"bestBeforeDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"rotationNumber","default":{"kind":"nothing"},"name":"rotationNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"rotationLine","default":{"kind":"nothing"},"name":"rotationLine","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"dutyPaid","default":{"kind":"nothing"},"name":"dutyPaid","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}]}}]}},"name":"GetProductStockDetailDto","version":{"kind":"nothing"}}};

export const snGetProductStockDetailDto: ADL.ScopedName = {moduleName:"ferovinum.app.dtos", name:"GetProductStockDetailDto"};

export function texprGetProductStockDetailDto(): ADL.ATypeExpr<GetProductStockDetailDto> {
  return {value : {typeRef : {kind: "reference", value : snGetProductStockDetailDto}, parameters : []}};
}

/**
 * API DTO for including in Purchase Request Line Items to indicate the stock detail for a product
 */
export interface SaveProductStockDetailDto {
  batchNumber: (string|null);
  bestBeforeDate: (common.LocalDate|null);
  rotationNumber: (string|null);
  rotationLine: (string|null);
  quantity: common.BigDecimal;
}

export function makeSaveProductStockDetailDto(
  input: {
    batchNumber: (string|null),
    bestBeforeDate: (common.LocalDate|null),
    rotationNumber: (string|null),
    rotationLine: (string|null),
    quantity: common.BigDecimal,
  }
): SaveProductStockDetailDto {
  return {
    batchNumber: input.batchNumber,
    bestBeforeDate: input.bestBeforeDate,
    rotationNumber: input.rotationNumber,
    rotationLine: input.rotationLine,
    quantity: input.quantity,
  };
}

const SaveProductStockDetailDto_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.dtos","decl":{"annotations":[{"value":"API DTO for including in Purchase Request Line Items to indicate the stock detail for a product\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"batchNumber","default":{"kind":"nothing"},"name":"batchNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"bestBeforeDate","default":{"kind":"nothing"},"name":"bestBeforeDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"rotationNumber","default":{"kind":"nothing"},"name":"rotationNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"rotationLine","default":{"kind":"nothing"},"name":"rotationLine","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"SaveProductStockDetailDto","version":{"kind":"nothing"}}};

export const snSaveProductStockDetailDto: ADL.ScopedName = {moduleName:"ferovinum.app.dtos", name:"SaveProductStockDetailDto"};

export function texprSaveProductStockDetailDto(): ADL.ATypeExpr<SaveProductStockDetailDto> {
  return {value : {typeRef : {kind: "reference", value : snSaveProductStockDetailDto}, parameters : []}};
}

export interface SaveProductStockDetailWithDutyPaidDto {
  batchNumber: (string|null);
  bestBeforeDate: (common.LocalDate|null);
  rotationNumber: (string|null);
  rotationLine: (string|null);
  quantity: common.BigDecimal;
  dutyPaid: (boolean|null);
}

export function makeSaveProductStockDetailWithDutyPaidDto(
  input: {
    batchNumber: (string|null),
    bestBeforeDate: (common.LocalDate|null),
    rotationNumber: (string|null),
    rotationLine: (string|null),
    quantity: common.BigDecimal,
    dutyPaid: (boolean|null),
  }
): SaveProductStockDetailWithDutyPaidDto {
  return {
    batchNumber: input.batchNumber,
    bestBeforeDate: input.bestBeforeDate,
    rotationNumber: input.rotationNumber,
    rotationLine: input.rotationLine,
    quantity: input.quantity,
    dutyPaid: input.dutyPaid,
  };
}

const SaveProductStockDetailWithDutyPaidDto_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.dtos","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"batchNumber","default":{"kind":"nothing"},"name":"batchNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"bestBeforeDate","default":{"kind":"nothing"},"name":"bestBeforeDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"rotationNumber","default":{"kind":"nothing"},"name":"rotationNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"rotationLine","default":{"kind":"nothing"},"name":"rotationLine","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"dutyPaid","default":{"kind":"nothing"},"name":"dutyPaid","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}]}}]}},"name":"SaveProductStockDetailWithDutyPaidDto","version":{"kind":"nothing"}}};

export const snSaveProductStockDetailWithDutyPaidDto: ADL.ScopedName = {moduleName:"ferovinum.app.dtos", name:"SaveProductStockDetailWithDutyPaidDto"};

export function texprSaveProductStockDetailWithDutyPaidDto(): ADL.ATypeExpr<SaveProductStockDetailWithDutyPaidDto> {
  return {value : {typeRef : {kind: "reference", value : snSaveProductStockDetailWithDutyPaidDto}, parameters : []}};
}

export interface ModelWithId<BaseEntityType, Model> {
  id: common_db.DbKey<BaseEntityType>;
  value: Model;
}

export function makeModelWithId<BaseEntityType, Model>(
  input: {
    id: common_db.DbKey<BaseEntityType>,
    value: Model,
  }
): ModelWithId<BaseEntityType, Model> {
  return {
    id: input.id,
    value: input.value,
  };
}

const ModelWithId_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.dtos","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":["BaseEntityType","Model"],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"typeParam","value":"BaseEntityType"},"parameters":[]}]}},{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"typeParam","value":"Model"},"parameters":[]}}]}},"name":"ModelWithId","version":{"kind":"nothing"}}};

export const snModelWithId: ADL.ScopedName = {moduleName:"ferovinum.app.dtos", name:"ModelWithId"};

export function texprModelWithId<BaseEntityType, Model>(texprBaseEntityType : ADL.ATypeExpr<BaseEntityType>, texprModel : ADL.ATypeExpr<Model>): ADL.ATypeExpr<ModelWithId<BaseEntityType, Model>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "ferovinum.app.dtos",name : "ModelWithId"}}, parameters : [texprBaseEntityType.value, texprModel.value]}};
}

/**
 * TODO: rename this to DTO instead of model to differentiate from the service model
 */
export interface OrganisationModel {
  businessName: string;
  currency: ferovinum_app_db.Currency;
  shortName: (common_strings.StringNE|null);
  awrsRegistrationNumber: (common_strings.StringNE|null);
  d2cFulfilmentFee: common.BigDecimal;
  masterAgreementSignedDates: common.LocalDate[];
  masterAgreementVersion: ferovinum_app_db.MasterAgreementVersion;
  feroEntity: ferovinum_app_db.FeroEntity;
  clientSegment: ferovinum_app_db.ClientSegment;
  facilitySegment: ferovinum_app_db.FacilitySegment;
  nominatedPurchaserFee: (common.BigDecimal|null);
  defaultMonthlyFee: (ferovinum_app_db.DefaultMonthlyFee|null);
  tradeSaleMonthlyFeeRate: (ferovinum_app_db.DefaultMonthlyFee|null);
  defaultThroughputFee: (common.BigDecimal|null);
  logoUrl: (string|null);
  contactEmail: (string|null);
  accountsEmails: string[];
  defaultFeroFxServiceCharge: common.BigDecimal;
  vatNumber: (common_strings.StringNE|null);
  crnNumber: (common_strings.StringNE|null);
  wowgrNumber: (common_strings.StringNE|null);
  naceIndustryCode: (common_strings.NACECode|null);
  bankAccountId: (ferovinum_app_db.BankAccountId|null);
  obligorLegalType: ferovinum_app_db.ObligorLegalType;
  /**
   * Whether trade sales for this org default to requiring funding (advance
   * cash upon delivery). Seeds the Additional Funding checkbox default on the
   * manual New Trade Sale flow; can still be overridden per trade sale.
   */
  defaultTradeSaleFunding: boolean;
}

export function makeOrganisationModel(
  input: {
    businessName: string,
    currency: ferovinum_app_db.Currency,
    shortName: (common_strings.StringNE|null),
    awrsRegistrationNumber: (common_strings.StringNE|null),
    d2cFulfilmentFee: common.BigDecimal,
    masterAgreementSignedDates: common.LocalDate[],
    masterAgreementVersion: ferovinum_app_db.MasterAgreementVersion,
    feroEntity: ferovinum_app_db.FeroEntity,
    clientSegment: ferovinum_app_db.ClientSegment,
    facilitySegment: ferovinum_app_db.FacilitySegment,
    nominatedPurchaserFee: (common.BigDecimal|null),
    defaultMonthlyFee: (ferovinum_app_db.DefaultMonthlyFee|null),
    tradeSaleMonthlyFeeRate: (ferovinum_app_db.DefaultMonthlyFee|null),
    defaultThroughputFee: (common.BigDecimal|null),
    logoUrl: (string|null),
    contactEmail: (string|null),
    accountsEmails: string[],
    defaultFeroFxServiceCharge?: common.BigDecimal,
    vatNumber: (common_strings.StringNE|null),
    crnNumber: (common_strings.StringNE|null),
    wowgrNumber: (common_strings.StringNE|null),
    naceIndustryCode: (common_strings.NACECode|null),
    bankAccountId?: (ferovinum_app_db.BankAccountId|null),
    obligorLegalType: ferovinum_app_db.ObligorLegalType,
    defaultTradeSaleFunding?: boolean,
  }
): OrganisationModel {
  return {
    businessName: input.businessName,
    currency: input.currency,
    shortName: input.shortName,
    awrsRegistrationNumber: input.awrsRegistrationNumber,
    d2cFulfilmentFee: input.d2cFulfilmentFee,
    masterAgreementSignedDates: input.masterAgreementSignedDates,
    masterAgreementVersion: input.masterAgreementVersion,
    feroEntity: input.feroEntity,
    clientSegment: input.clientSegment,
    facilitySegment: input.facilitySegment,
    nominatedPurchaserFee: input.nominatedPurchaserFee,
    defaultMonthlyFee: input.defaultMonthlyFee,
    tradeSaleMonthlyFeeRate: input.tradeSaleMonthlyFeeRate,
    defaultThroughputFee: input.defaultThroughputFee,
    logoUrl: input.logoUrl,
    contactEmail: input.contactEmail,
    accountsEmails: input.accountsEmails,
    defaultFeroFxServiceCharge: input.defaultFeroFxServiceCharge === undefined ? "0" : input.defaultFeroFxServiceCharge,
    vatNumber: input.vatNumber,
    crnNumber: input.crnNumber,
    wowgrNumber: input.wowgrNumber,
    naceIndustryCode: input.naceIndustryCode,
    bankAccountId: input.bankAccountId === undefined ? null : input.bankAccountId,
    obligorLegalType: input.obligorLegalType,
    defaultTradeSaleFunding: input.defaultTradeSaleFunding === undefined ? false : input.defaultTradeSaleFunding,
  };
}

const OrganisationModel_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.dtos","decl":{"annotations":[{"value":"TODO: rename this to DTO instead of model to differentiate from the service model\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"businessName","default":{"kind":"nothing"},"name":"businessName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}},{"annotations":[],"serializedName":"shortName","default":{"kind":"nothing"},"name":"shortName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"awrsRegistrationNumber","default":{"kind":"nothing"},"name":"awrsRegistrationNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"d2cFulfilmentFee","default":{"kind":"nothing"},"name":"d2cFulfilmentFee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"masterAgreementSignedDates","default":{"kind":"nothing"},"name":"masterAgreementSignedDates","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"masterAgreementVersion","default":{"kind":"nothing"},"name":"masterAgreementVersion","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"MasterAgreementVersion"}},"parameters":[]}},{"annotations":[],"serializedName":"feroEntity","default":{"kind":"nothing"},"name":"feroEntity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"FeroEntity"}},"parameters":[]}},{"annotations":[],"serializedName":"clientSegment","default":{"kind":"nothing"},"name":"clientSegment","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ClientSegment"}},"parameters":[]}},{"annotations":[],"serializedName":"facilitySegment","default":{"kind":"nothing"},"name":"facilitySegment","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"FacilitySegment"}},"parameters":[]}},{"annotations":[],"serializedName":"nominatedPurchaserFee","default":{"kind":"nothing"},"name":"nominatedPurchaserFee","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"defaultMonthlyFee","default":{"kind":"nothing"},"name":"defaultMonthlyFee","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DefaultMonthlyFee"}},"parameters":[]}]}},{"annotations":[],"serializedName":"tradeSaleMonthlyFeeRate","default":{"kind":"nothing"},"name":"tradeSaleMonthlyFeeRate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DefaultMonthlyFee"}},"parameters":[]}]}},{"annotations":[],"serializedName":"defaultThroughputFee","default":{"kind":"nothing"},"name":"defaultThroughputFee","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"logoUrl","default":{"kind":"nothing"},"name":"logoUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"contactEmail","default":{"kind":"nothing"},"name":"contactEmail","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"accountsEmails","default":{"kind":"nothing"},"name":"accountsEmails","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"defaultFeroFxServiceCharge","default":{"kind":"just","value":"0"},"name":"defaultFeroFxServiceCharge","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"vatNumber","default":{"kind":"nothing"},"name":"vatNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"crnNumber","default":{"kind":"nothing"},"name":"crnNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"wowgrNumber","default":{"kind":"nothing"},"name":"wowgrNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"naceIndustryCode","default":{"kind":"nothing"},"name":"naceIndustryCode","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"NACECode"}},"parameters":[]}]}},{"annotations":[],"serializedName":"bankAccountId","default":{"kind":"just","value":null},"name":"bankAccountId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"BankAccountId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"obligorLegalType","default":{"kind":"nothing"},"name":"obligorLegalType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ObligorLegalType"}},"parameters":[]}},{"annotations":[{"value":"Whether trade sales for this org default to requiring funding (advance\ncash upon delivery). Seeds the Additional Funding checkbox default on the\nmanual New Trade Sale flow; can still be overridden per trade sale.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"defaultTradeSaleFunding","default":{"kind":"just","value":false},"name":"defaultTradeSaleFunding","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"OrganisationModel","version":{"kind":"nothing"}}};

export const snOrganisationModel: ADL.ScopedName = {moduleName:"ferovinum.app.dtos", name:"OrganisationModel"};

export function texprOrganisationModel(): ADL.ATypeExpr<OrganisationModel> {
  return {value : {typeRef : {kind: "reference", value : snOrganisationModel}, parameters : []}};
}

export type OrganisationModelWithId = ModelWithId<ferovinum_app_db.Organisation, OrganisationModel>;

const OrganisationModelWithId_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.dtos","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.dtos","name":"ModelWithId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Organisation"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.dtos","name":"OrganisationModel"}},"parameters":[]}]}}},"name":"OrganisationModelWithId","version":{"kind":"nothing"}}};

export const snOrganisationModelWithId: ADL.ScopedName = {moduleName:"ferovinum.app.dtos", name:"OrganisationModelWithId"};

export function texprOrganisationModelWithId(): ADL.ATypeExpr<OrganisationModelWithId> {
  return {value : {typeRef : {kind: "reference", value : snOrganisationModelWithId}, parameters : []}};
}

export interface AssembledComponentProductDTO {
  product: ProductDTOWithId;
  quantity: number;
}

export function makeAssembledComponentProductDTO(
  input: {
    product: ProductDTOWithId,
    quantity: number,
  }
): AssembledComponentProductDTO {
  return {
    product: input.product,
    quantity: input.quantity,
  };
}

const AssembledComponentProductDTO_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.dtos","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"product","default":{"kind":"nothing"},"name":"product","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.dtos","name":"ProductDTOWithId"}},"parameters":[]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"AssembledComponentProductDTO","version":{"kind":"nothing"}}};

export const snAssembledComponentProductDTO: ADL.ScopedName = {moduleName:"ferovinum.app.dtos", name:"AssembledComponentProductDTO"};

export function texprAssembledComponentProductDTO(): ADL.ATypeExpr<AssembledComponentProductDTO> {
  return {value : {typeRef : {kind: "reference", value : snAssembledComponentProductDTO}, parameters : []}};
}

export interface ProductDTO {
  code: common_strings.StringNE;
  name: common_strings.StringNE;
  producerName: common_strings.StringNE;
  productDate: ferovinum_app_db.ProductDate;
  vesselSize: (ferovinum_app_db.VesselSize|null);
  unitType: ferovinum_app_db.UnitType;
  countryOfOrigin: common.Country;
  regionOrigin: string;
  alcoholByVolumePc: AbvValue;
  productType: ferovinum_app_db.ProductType;
  alcoholDetail: ferovinum_app_db.AlcoholDetail;
  vesselType: ferovinum_app_db.VesselType;
  ownerId: ferovinum_app_db.OrganisationId;
  createdAt: common.Instant;
  updatedAt: common.Instant;
  batchRequired: boolean;
  bestBeforeDateRequired: boolean;
  parentProductDetails: (ferovinum_app_db.ParentProductDetailsId|null);
  assembledComponentProducts: (AssembledComponentProductDTO[]|null);
}

export function makeProductDTO(
  input: {
    code: common_strings.StringNE,
    name: common_strings.StringNE,
    producerName: common_strings.StringNE,
    productDate: ferovinum_app_db.ProductDate,
    vesselSize: (ferovinum_app_db.VesselSize|null),
    unitType: ferovinum_app_db.UnitType,
    countryOfOrigin: common.Country,
    regionOrigin: string,
    alcoholByVolumePc: AbvValue,
    productType: ferovinum_app_db.ProductType,
    alcoholDetail: ferovinum_app_db.AlcoholDetail,
    vesselType: ferovinum_app_db.VesselType,
    ownerId: ferovinum_app_db.OrganisationId,
    createdAt: common.Instant,
    updatedAt: common.Instant,
    batchRequired: boolean,
    bestBeforeDateRequired: boolean,
    parentProductDetails: (ferovinum_app_db.ParentProductDetailsId|null),
    assembledComponentProducts: (AssembledComponentProductDTO[]|null),
  }
): ProductDTO {
  return {
    code: input.code,
    name: input.name,
    producerName: input.producerName,
    productDate: input.productDate,
    vesselSize: input.vesselSize,
    unitType: input.unitType,
    countryOfOrigin: input.countryOfOrigin,
    regionOrigin: input.regionOrigin,
    alcoholByVolumePc: input.alcoholByVolumePc,
    productType: input.productType,
    alcoholDetail: input.alcoholDetail,
    vesselType: input.vesselType,
    ownerId: input.ownerId,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
    batchRequired: input.batchRequired,
    bestBeforeDateRequired: input.bestBeforeDateRequired,
    parentProductDetails: input.parentProductDetails,
    assembledComponentProducts: input.assembledComponentProducts,
  };
}

const ProductDTO_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.dtos","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"code","default":{"kind":"nothing"},"name":"code","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"producerName","default":{"kind":"nothing"},"name":"producerName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"productDate","default":{"kind":"nothing"},"name":"productDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductDate"}},"parameters":[]}},{"annotations":[],"serializedName":"vesselSize","default":{"kind":"nothing"},"name":"vesselSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"VesselSize"}},"parameters":[]}]}},{"annotations":[],"serializedName":"unitType","default":{"kind":"nothing"},"name":"unitType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"UnitType"}},"parameters":[]}},{"annotations":[],"serializedName":"countryOfOrigin","default":{"kind":"nothing"},"name":"countryOfOrigin","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Country"}},"parameters":[]}},{"annotations":[],"serializedName":"regionOrigin","default":{"kind":"nothing"},"name":"regionOrigin","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"alcoholByVolumePc","default":{"kind":"nothing"},"name":"alcoholByVolumePc","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.dtos","name":"AbvValue"}},"parameters":[]}},{"annotations":[],"serializedName":"productType","default":{"kind":"nothing"},"name":"productType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductType"}},"parameters":[]}},{"annotations":[],"serializedName":"alcoholDetail","default":{"kind":"nothing"},"name":"alcoholDetail","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"AlcoholDetail"}},"parameters":[]}},{"annotations":[],"serializedName":"vesselType","default":{"kind":"nothing"},"name":"vesselType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"VesselType"}},"parameters":[]}},{"annotations":[],"serializedName":"ownerId","default":{"kind":"nothing"},"name":"ownerId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"batchRequired","default":{"kind":"nothing"},"name":"batchRequired","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"bestBeforeDateRequired","default":{"kind":"nothing"},"name":"bestBeforeDateRequired","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"parentProductDetails","default":{"kind":"nothing"},"name":"parentProductDetails","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ParentProductDetailsId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"assembledComponentProducts","default":{"kind":"nothing"},"name":"assembledComponentProducts","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.dtos","name":"AssembledComponentProductDTO"}},"parameters":[]}]}]}}]}},"name":"ProductDTO","version":{"kind":"nothing"}}};

export const snProductDTO: ADL.ScopedName = {moduleName:"ferovinum.app.dtos", name:"ProductDTO"};

export function texprProductDTO(): ADL.ATypeExpr<ProductDTO> {
  return {value : {typeRef : {kind: "reference", value : snProductDTO}, parameters : []}};
}

export type ProductDTOWithId = ModelWithId<ferovinum_app_db.Product, ProductDTO>;

const ProductDTOWithId_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.dtos","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.dtos","name":"ModelWithId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Product"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.dtos","name":"ProductDTO"}},"parameters":[]}]}}},"name":"ProductDTOWithId","version":{"kind":"nothing"}}};

export const snProductDTOWithId: ADL.ScopedName = {moduleName:"ferovinum.app.dtos", name:"ProductDTOWithId"};

export function texprProductDTOWithId(): ADL.ATypeExpr<ProductDTOWithId> {
  return {value : {typeRef : {kind: "reference", value : snProductDTOWithId}, parameters : []}};
}

export interface SupplierDTO {
  name: common_strings.StringNE;
  contactName: common_strings.StringNE;
  contactMobile: common_strings.StringNE;
  contactEmail: common_strings.StringNE;
  locale: ferovinum_app_db.Locale;
  status: ferovinum_app_db.ApprovalStatus;
  approvedCurrencies: ferovinum_app_db.Currency[];
  bankAccountId: (ferovinum_app_db.BankAccountId|null);
}

export function makeSupplierDTO(
  input: {
    name: common_strings.StringNE,
    contactName: common_strings.StringNE,
    contactMobile: common_strings.StringNE,
    contactEmail: common_strings.StringNE,
    locale: ferovinum_app_db.Locale,
    status: ferovinum_app_db.ApprovalStatus,
    approvedCurrencies: ferovinum_app_db.Currency[],
    bankAccountId?: (ferovinum_app_db.BankAccountId|null),
  }
): SupplierDTO {
  return {
    name: input.name,
    contactName: input.contactName,
    contactMobile: input.contactMobile,
    contactEmail: input.contactEmail,
    locale: input.locale,
    status: input.status,
    approvedCurrencies: input.approvedCurrencies,
    bankAccountId: input.bankAccountId === undefined ? null : input.bankAccountId,
  };
}

const SupplierDTO_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.dtos","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"contactName","default":{"kind":"nothing"},"name":"contactName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"contactMobile","default":{"kind":"nothing"},"name":"contactMobile","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"contactEmail","default":{"kind":"nothing"},"name":"contactEmail","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"locale","default":{"kind":"nothing"},"name":"locale","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Locale"}},"parameters":[]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ApprovalStatus"}},"parameters":[]}},{"annotations":[],"serializedName":"approvedCurrencies","default":{"kind":"nothing"},"name":"approvedCurrencies","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}]}},{"annotations":[],"serializedName":"bankAccountId","default":{"kind":"just","value":null},"name":"bankAccountId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"BankAccountId"}},"parameters":[]}]}}]}},"name":"SupplierDTO","version":{"kind":"nothing"}}};

export const snSupplierDTO: ADL.ScopedName = {moduleName:"ferovinum.app.dtos", name:"SupplierDTO"};

export function texprSupplierDTO(): ADL.ATypeExpr<SupplierDTO> {
  return {value : {typeRef : {kind: "reference", value : snSupplierDTO}, parameters : []}};
}

export type SupplierDTOWithId = ModelWithId<ferovinum_app_db.Supplier, SupplierDTO>;

const SupplierDTOWithId_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.dtos","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.dtos","name":"ModelWithId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Supplier"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.dtos","name":"SupplierDTO"}},"parameters":[]}]}}},"name":"SupplierDTOWithId","version":{"kind":"nothing"}}};

export const snSupplierDTOWithId: ADL.ScopedName = {moduleName:"ferovinum.app.dtos", name:"SupplierDTOWithId"};

export function texprSupplierDTOWithId(): ADL.ATypeExpr<SupplierDTOWithId> {
  return {value : {typeRef : {kind: "reference", value : snSupplierDTOWithId}, parameters : []}};
}

/**
 * DTO for user organization data with permissions
 */
export interface AppUserOrganisationDTO {
  organisationId: ferovinum_app_db.OrganisationId;
  appUserId: ferovinum_app_db.AppUserId;
  fullname: common_strings.StringNE;
  email: common_strings.StringNE;
  jobTitle: string;
  permissions: ferovinum_app_db.OrgUserPermission[];
}

export function makeAppUserOrganisationDTO(
  input: {
    organisationId: ferovinum_app_db.OrganisationId,
    appUserId: ferovinum_app_db.AppUserId,
    fullname: common_strings.StringNE,
    email: common_strings.StringNE,
    jobTitle: string,
    permissions?: ferovinum_app_db.OrgUserPermission[],
  }
): AppUserOrganisationDTO {
  return {
    organisationId: input.organisationId,
    appUserId: input.appUserId,
    fullname: input.fullname,
    email: input.email,
    jobTitle: input.jobTitle,
    permissions: input.permissions === undefined ? [] : input.permissions,
  };
}

const AppUserOrganisationDTO_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.dtos","decl":{"annotations":[{"value":"DTO for user organization data with permissions\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"appUserId","default":{"kind":"nothing"},"name":"appUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"AppUserId"}},"parameters":[]}},{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"jobTitle","default":{"kind":"nothing"},"name":"jobTitle","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"permissions","default":{"kind":"just","value":[]},"name":"permissions","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrgUserPermission"}},"parameters":[]}]}}]}},"name":"AppUserOrganisationDTO","version":{"kind":"nothing"}}};

export const snAppUserOrganisationDTO: ADL.ScopedName = {moduleName:"ferovinum.app.dtos", name:"AppUserOrganisationDTO"};

export function texprAppUserOrganisationDTO(): ADL.ATypeExpr<AppUserOrganisationDTO> {
  return {value : {typeRef : {kind: "reference", value : snAppUserOrganisationDTO}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.dtos.AbvValue" : AbvValue_AST,
  "ferovinum.app.dtos.AbvRange" : AbvRange_AST,
  "ferovinum.app.dtos.GetProductStockDetailDto" : GetProductStockDetailDto_AST,
  "ferovinum.app.dtos.SaveProductStockDetailDto" : SaveProductStockDetailDto_AST,
  "ferovinum.app.dtos.SaveProductStockDetailWithDutyPaidDto" : SaveProductStockDetailWithDutyPaidDto_AST,
  "ferovinum.app.dtos.ModelWithId" : ModelWithId_AST,
  "ferovinum.app.dtos.OrganisationModel" : OrganisationModel_AST,
  "ferovinum.app.dtos.OrganisationModelWithId" : OrganisationModelWithId_AST,
  "ferovinum.app.dtos.AssembledComponentProductDTO" : AssembledComponentProductDTO_AST,
  "ferovinum.app.dtos.ProductDTO" : ProductDTO_AST,
  "ferovinum.app.dtos.ProductDTOWithId" : ProductDTOWithId_AST,
  "ferovinum.app.dtos.SupplierDTO" : SupplierDTO_AST,
  "ferovinum.app.dtos.SupplierDTOWithId" : SupplierDTOWithId_AST,
  "ferovinum.app.dtos.AppUserOrganisationDTO" : AppUserOrganisationDTO_AST
};
